<div class="nav-container" [class.collapsed]="isCollapsed" [class.menu-initialized]="true">
  <div
    class="flex-column"
    role="tablist"
    aria-orientation="vertical"
  >

  <a
    *ngIf="userIsSmartPropertyAdmin"
    class="nav-link"
    routerLinkActive="router-link-active"
    [routerLink]="['/useraccount/admin/portfolios']"
    [title]="isCollapsed ? 'Portfolios' : ''"
    data-testid="left-nav-portfolios"
  >
    <i class="fa-solid fa-apartment"></i>
    <span class="sp-menu-text">Portfolios</span>
  </a>

  <a
    class="nav-link"
    routerLinkActive="router-link-active"
    [routerLink]="['/useraccount/admin/properties']"
    [title]="isCollapsed ? 'Properties' : ''"
    data-testid="left-nav-properties"
  >
    <i class="fa-solid fa-house-building"></i>
    <span class="sp-menu-text">Properties</span>
  </a>

  <a
    *ngIf="userIsSmartPropertyAdmin"
    class="nav-link"
    routerLinkActive="router-link-active"
    [routerLink]="['/useraccount/admin/users']"
    [title]="isCollapsed ? 'Users' : ''"
    data-testid="left-nav-users"
  >
    <i class="fa-jelly fa-regular fa-user"></i>
    <span class="sp-menu-text">Users</span>
  </a>

  <!-- Hide Menu Item -->
    <a
    class="nav-link hide-menu-item"
    (click)="toggleCollapse()"
    [title]="isCollapsed ? 'Expand navigation' : 'Collapse navigation'"
  >
  <i class="fa-regular" [class.fa-arrow-left-to-line]="!isCollapsed" [class.fa-arrow-right-to-line]="isCollapsed"></i>
    <span class="sp-menu-text" *ngIf="!isCollapsed">Hide</span>
  </a>

  </div>
</div>